import React from "react";
import Cards from "./Cards";

const Container = () => {
  return <div 
  className="container">
      <Cards/>
    
  </div>
};

export default Container;